export const robots = [
  {
    id: 1,
    name: 'Adebola Sumbo',
    username: 'Bret',
    email: 'Sincere@april.biz'
  },
  {
    id: 2,
    name: 'Blessing Ogechi',
    username: 'Antonette',
    email: 'Shanna@melissa.tv'
  },
  {
    id: 3,
    name: 'Clementine Bauch',
    username: 'Samantha',
    email: 'Nathan@yesenia.net'
  },
  {
    id: 4,
    name: 'Dayo Fabunmi',
    username: 'Karianne',
    email: 'Julianne.OConner@kory.org'
  },
  {
    id: 5,
    name: 'Emmanuel Adesupile',
    username: 'Kamren',
    email: 'Lucio_Hettinger@annie.ca'
  },
  {
    id: 6,
    name: 'Faruq Arigbigbe',
    username: 'Leopoldo_Corkery',
    email: 'Karley_Dach@jasper.info'
  },
  {
    id: 7,
    name: 'Ganiyu Mustapha',
    username: 'Elwyn.Skiles',
    email: 'Telly.Hoeger@billy.biz'
  },
  {
    id: 8,
    name: 'Hassan Udo',
    username: 'Maxime_Nienow',
    email: 'Sherwood@rosamond.me'
  },
  {
    id: 9,
    name: 'Isaac Richard',
    username: 'Delphine',
    email: 'Chaim_McDermott@dana.io'
  },
  {
    id: 10,
    name: 'John Bull',
    username: 'Morih.Stanton',
    email: 'Rey.Paderg@karina.biz'
  },
  {
    id: 11,
    name: 'Kayode Ade',
    username: 'Kjjd.Losks',
    email: 'Rpy.Paeg@karia.bz'
  },
  {
    id: 12,
    name: 'Lolade Aishat',
    username: 'Moriah.Stanton',
    email: 'Rey.Padberg@karina.biz'
  },
  {
    id: 13,
    name: 'Moses Bush',
    username: 'Moriah.Stanton',
    email: 'Rey.Padberg@karina.biz'
  },
  {
    id: 14,
    name: 'Nosa Riyoma',
    username: 'Moriah.Stanton',
    email: 'Rey.Padberg@karina.biz'
  },
  {
    id: 15,
    name: 'Olu Tase',
    username: 'Moriah.Stanton',
    email: 'Rey.Padberg@karina.biz'
  },
  {
    id: 16,
    name: 'Paul Jaris',
    username: 'Moriah.Stanton',
    email: 'Rey.Padberg@karina.biz'
  },
  {
    id: 17,
    name: 'Queen Shaidat',
    username: 'Moriah.Stanton',
    email: 'Rey.Padberg@karina.biz'
  },
  {
    id: 18,
    name: 'Raidat Napoli',
    username: 'Moriah.Stanton',
    email: 'Rey.Padberg@karina.biz'
  },
  {
    id: 19,
    name: 'Saidat Bimpe',
    username: 'Moriah.Stanton',
    email: 'Rey.Padberg@karina.biz'
  },
  {
    id: 20,
    name: 'Tolu Aide',
    username: 'Moriah.Stanton',
    email: 'Rey.Padberg@karina.biz'
  },
  {
    id: 21,
    name: 'Udo Ginade',
    username: 'Moriah.Stanton',
    email: 'Rey.Padberg@karina.biz'
  },
  {
    id: 22,
    name: 'Vivian Carlos',
    username: 'Moriah.Stanton',
    email: 'Rey.Padberg@karina.biz'
  },
  {
    id: 23,
    name: 'Wale Thomas',
    username: 'Moriah.Stanton',
    email: 'Rey.Padberg@karina.biz'
  },
  {
    id: 24,
    name: 'Xiaomi Jules',
    username: 'Moriah.Stanton',
    email: 'Rey.Padberg@karina.biz'
  },
  {
    id: 25,
    name: 'Yolis Yhoma',
    username: 'Moriah.Stanton',
    email: 'Rey.Padberg@karina.biz'
  },
  {
    id: 26,
    name: 'Ziko Loris',
    username: 'Moriah.Stanton',
    email: 'Rey.Padberg@karina.biz'
  },
  {
    id: 27,
    name: 'Sidiru Loris',
    username: 'Sidru.Stanton',
    email: 'Rey.Padberg@karina.biz'
  },
];
